import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api, fmtDate } from "@/lib/api";
import { Calendar as CalendarIcon } from "lucide-react";

export default function Appointments() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/appointments/mine"); setItems(data); } catch {}
    })();
  }, []);
  return (
    <DashboardLayout>
      <p className="eyebrow">Schedule</p>
      <h1 className="font-display text-3xl font-semibold mt-2">Appointments</h1>
      <div className="mt-6 bg-white border border-[var(--adn-line)] p-6">
        {items.length === 0 ? (
          <div className="text-center py-12">
            <CalendarIcon className="mx-auto text-[var(--adn-text-muted)]" size={28} />
            <p className="font-display font-semibold mt-3">No appointments yet</p>
            <p className="text-sm text-[var(--adn-text-soft)] mt-1">Schedule property walkthroughs and provider calls right from a property page.</p>
          </div>
        ) : (
          <ul className="divide-y divide-[var(--adn-line)]">
            {items.map((a) => (
              <li key={a.appointment_id} className="py-4 flex items-center justify-between">
                <div>
                  <div className="font-display font-semibold">{fmtDate(a.start_at)}</div>
                  <div className="text-sm text-[var(--adn-text-soft)]">{a.location || "Location TBD"} · {a.duration_min}min</div>
                </div>
                <span className="pill pill-neutral">{a.status}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </DashboardLayout>
  );
}
